import { State } from "../types";

export const initialState: State = {
  newCreditLimit: "",
  personalInformation: {
    relationshipStatus: "",
    numberOfDependants: "",
  },
  residentialAddress: {
    residentialStatus: "",
    mortgageOrRent: "",
    timeAtCurrentAddress: {
      years: "",
      months: "",
    },
  },
  additionalDebts: {
    nzHaveOtherLoans: "",
    nzOwingLoan: "",
    nzCurrentLoans: "",
    nzIntendPayOff: "",
    nzTotalCreditLimit: "",
    nzTotalAmountOwing: "",
  },
  employmentAndIncome: {
    employmentDetails: {
      employmentStatus: "",
      occupation: "",
      industry: "",
      timeWithCurrentEmployer: {
        years: "",
        months: "",
      },
    },
    employerName: "",
    netIncome: {
      amount: "",
      frequency: "monthly",
    },
    otherSourcesOfIncome: "",
    otherEmploymentDetails: {
      employmentStatus: "",
      occupation: "",
      industry: "",
      timeWithCurrentEmployer: {
        years: "",
        months: "",
      },
    },
    otherEmployerName: "",
    otherIncome: {
      amount: "",
      frequency: "monthly",
    },
    incomeChangesInFuture: "",
    nzTotalIncome: null,
  },
  monthlyExpenses: {
    expensesFrequency: {
      nzMortgage: {
        amount: "",
        frequency: "monthly",
      },
      nzSecondaryMortgage: {
        amount: "",
        frequency: "monthly",
      },
      nzPropertyRates: {
        amount: "",
        frequency: "monthly",
      },
      nzOtherPropertyExpenses: {
        amount: "",
        frequency: "monthly",
      },
      nzFoodGroceriesEntertainment: {
        amount: "",
        frequency: "monthly",
      },
      nzPersonalInsurance: {
        amount: "",
        frequency: "monthly",
      },
      nzGeneralInsurance: {
        amount: "",
        frequency: "monthly",
      },
      nzTransportAuto: {
        amount: "",
        frequency: "monthly",
      },
      nzEducationChildcare: {
        amount: "",
        frequency: "monthly",
      },
      nzPersonalFitnessMedical: {
        amount: "",
        frequency: "monthly",
      },
      nzAnyAdditionalExpense: {
        amount: "",
        frequency: "monthly",
      },
    },
    nzAllExpensesForHousehold: "",
    nzHaveOffsetMortgage: "",
    nzRevolvingMortgage: "",
    nzTotalExpenses: null,
  },
};
